module.exports = __webpack_public_path__ + "static/media/Michael_Fang_Resume.207afd14.pdf";